import React from "react";
import "./Loader.css";

const Loader = ({ show, message = "Processing please wait..." }) => {
  if (!show) return null;

  return (
    <div className="loading-overlay">
      <div className="loading-box">
        <div className="spinner"></div>
        <p>{message}</p>
      </div>
    </div>
  );
};

export default Loader;
